import type {
  ConnectionProfileCreate,
  ConnectionProfileResponse,
  ConnectionProfileUpdate,
} from '@flixflow/shared';
import { apiFetch } from './client.js';

export interface ProbeResult {
  ok: boolean;
  durationMs: number;
  error?: string;
}

const BASE = '/api/connection-profiles';

export function listProfiles(): Promise<ConnectionProfileResponse[]> {
  return apiFetch<ConnectionProfileResponse[]>(BASE);
}

export function getProfile(id: string): Promise<ConnectionProfileResponse> {
  return apiFetch<ConnectionProfileResponse>(`${BASE}/${id}`);
}

export function createProfile(data: ConnectionProfileCreate): Promise<ConnectionProfileResponse> {
  return apiFetch<ConnectionProfileResponse>(BASE, {
    method: 'POST',
    body: data,
  });
}

export function updateProfile(
  id: string,
  data: ConnectionProfileUpdate,
): Promise<ConnectionProfileResponse> {
  return apiFetch<ConnectionProfileResponse>(`${BASE}/${id}`, {
    method: 'PUT',
    body: data,
  });
}

export function deleteProfile(id: string): Promise<void> {
  return apiFetch<void>(`${BASE}/${id}`, { method: 'DELETE' });
}

export function testProfile(id: string): Promise<ProbeResult> {
  return apiFetch<ProbeResult>(`${BASE}/${id}/test`, { method: 'POST' });
}
